import { render, staticRenderFns } from "./UserLogsModal.vue?vue&type=template&id=7835b2d8&scoped=true"
import script from "./UserLogsModal.vue?vue&type=script&lang=js"
export * from "./UserLogsModal.vue?vue&type=script&lang=js"
import style0 from "./UserLogsModal.vue?vue&type=style&index=0&id=7835b2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7835b2d8",
  null
  
)

export default component.exports